import * as Sentry from '@sentry/react';
import { useEffect } from 'react';

export type ProjectDetailsRoute = 'details' | 'details-tabs' | 'dimensions';

/**
 * Tags Sentry events with the active project and tab while the user is on project detail screens.
 */
export function useSentryProjectScope(options: {
  projectId: string | null | undefined;
  projectTitle?: string | null;
  activeTab?: string;
  environment?: string;
  route: ProjectDetailsRoute;
}): void {
  const { projectId, projectTitle, activeTab, environment, route } = options;

  useEffect(() => {
    if (!projectId) {
      Sentry.setTag('projectId', '');
      Sentry.setContext('project', { route });
      return;
    }

    Sentry.setTag('projectId', projectId);
    if (projectTitle) {
      Sentry.setTag('projectTitle', projectTitle);
    }
    Sentry.setContext('project', {
      projectId,
      projectTitle: projectTitle ?? undefined,
      activeTab,
      environment,
      route
    });
  }, [projectId, projectTitle, activeTab, environment, route]);
}
